import React from 'react'

const FeatureEllipse = () => (
  <li className="feature-assignment-ellipsis">
    <i className="fa fa-ellipsis-h" />
  </li>
)

export default FeatureEllipse
